import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/tenantUsers/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/tenantUsers/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/tenantUsers/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/tenantUsers/delete',
    method: 'post',
    data
  })
}


export function getTenantList(tenantId) { 
  return request({
    url: '/tenantUsers/getTenantList?tenantId=' + tenantId,
    method: 'get',
  })
}
export function getRoles() {
  return request({
    url: '/tenantUsers/getroles',
    method: 'get'
  })
} 

export function get(id) {
  return request({
    url: '/tenantUsers/get?id=' + id,
    method: 'get'
  })
 }

export function getCurrentUserRole() {
  return request({
    url: '/tenantUsers/getCurrentUserRole',
    method: 'get'
  })
}